import AiGenConsts from './AiGenConsts';

const initialState = {
    pollData: [],            // First group (landing page) 
    votesData: [],           // Remaining groups (poll screen)
    firstGroupUserChoice: null, // The user's choice for the first group
    status: 'idle',          // Track loading, success, or failure
    error: null,             // Error message if something goes wrong
};

const AiGenReducer = (state = initialState, action) => {
    switch (action.type) {
        case AiGenConsts.FETCH_IMAGES_SUCCESS: {
            const { pollData, votesData } = action.payload;
            return {
                ...state,
                pollData,
                votesData,
                status: 'success',
                error: null,
            };
        }

        case AiGenConsts.FETCH_IMAGES_FAILURE: {
            return {
                ...state,
                pollData: [],
                votesData: [],
                status: 'failure',
                error: action.payload,
            };
        }

        case AiGenConsts.SET_POLL_DATA: {
            return {
                ...state,
                pollData: action.payload,
            };
        }

        case AiGenConsts.SET_VOTES_DATA: {
            return {
                ...state,
                votesData: action.payload,
            };
        }

        case AiGenConsts.SET_FIRST_GROUP_CHOICE: {
            return {
                ...state,
                firstGroupUserChoice: action.payload,
            };
        }

        case AiGenConsts.VOTE_SUCCESS: {
            return {
                ...state,
                status: 'vote_success',
            };
        }

        case AiGenConsts.VOTE_FAILURE: {
            return {
                ...state,
                status: 'vote_failure',
                error: action.payload,
            };
        }

        default:
            return state;
    }
};

export default AiGenReducer;